export default {
    state: {
        formResult: {},
        tabData: [],
    },
    mutations: {
        setFormResult(state, data) {
            state.formResult = data;
        },
        setTbaleData(state, data) {
            state.tabData = data;
        }
    },
    getters: {
        formResult(state) {
            return state.formResult;
        },
        getTableData(state) {
            return state.tabData;
        }
    },
};